//Hooks useAPI OVH

import { useState, useEffect } from 'react';
import { auth } from '../config/firebase';
import { getDoc, doc } from 'firebase/firestore';
import { firestore } from '../config/firebase';
import { toast } from 'react-toastify';


const useApi = () => {
    const [senders, setSenders] = useState([]);
    const [error, setError] = useState(null);
    const [keys, setKeys] = useState([]); // [applicationKey, applicationSecret, consumerKey, serviceName]
    const [code, setCode] = useState([]);
    const [loading, setLoading] = useState(false);

    var CryptoJS = require("crypto-js");  
    const getSenders = () => {
      const applicationKey = '768e6f3278cf4db6'
      const applicationSecret = 'fd37b0ae7599f1a31c0a4cc1f83c6802'
      const consumerKey = '870950239074808e64fbfddb8e7befe1'
      const serviceName = 'sms-ae16568-1'
      const timestamp = Math.floor(Date.now() / 1000)
      const body = ""

      const url = 'https://eu.api.ovh.com/1.0/sms/' + serviceName + '/senders'
      const signature = '$1$' + CryptoJS.SHA1(applicationSecret + '+' + consumerKey + '+GET+' + url + "+" + body + '+' + timestamp)

      fetch(url, {
          method: 'GET',
          headers: {
              'Content-Type': 'application/json',
              'X-Ovh-Application': applicationKey,
              'X-Ovh-Consumer' : consumerKey,
              'X-Ovh-Signature' : signature,
              'X-Ovh-Timestamp' : timestamp,
          },
      })
      .then(response => response.json())
      .then(data => {
          setSenders(data)
      })
      .catch(error => {
          setError(error)
      })
    }

    const getKeysFromFirebase = async () => {
        const docRef = doc(firestore, "api", "A1eGHbbOYS3VUXIuGKO5");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            setKeys({id: docSnap.id, ...docSnap.data()})
        } else {
            console.error("keys not found");
        }
    }

    const getKeys = async () => {
        const docRef = doc(firestore, "api", "tT1QS7p8QOBT7PARbtMn");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            setCode({id: docSnap.id, ...docSnap.data()})
        } else {
            console.error("keys not found");
        }
    }

     
    useEffect(() => {
        getSenders()
        getKeysFromFirebase()
        getKeys()
    }, [])

    return { senders, keys, code, error, loading };
}

export default useApi;